module.exports = __webpack_public_path__ + "img/9788949120829.a0eaf541.jpg";